import { type StateValue, interpret } from 'xstate';
import { toStatePaths } from 'xstate/lib/utils';
import { getLogger } from '../../libs/logger';
import { callStateMachine } from './callStateMachine';

/**
 * Convert state value to string dot notation, useful for log readability.
 */
const toStatePath = (value: StateValue): string =>
  toStatePaths(value).flat().join('.');

/**
 * The call state machine is an application singleton.
 * Send 'START' to start the call-init process.
 */
export const callActor = interpret(callStateMachine);

callActor.start();

/**
 * Log transitions and state changes.
 */
callActor.onTransition((state) => {
  if (typeof window !== 'undefined') {
    const { event, value, history } = state;
    const transition = event.type;
    const currentState = toStatePath(value);
    const prevState = history ? toStatePath(history.value) : 'null';

    if (prevState !== 'null') {
      const logger = getLogger('callStateMachine');
      logger.info(
        `[callStateMachine/transition] ${transition} : ${prevState} -> ${currentState}`,
        { transition, state: currentState, prevState },
      );
    }
  }
});
